<template>
  <div class="container-sport">
    <b-row>
      <b-col cols="12" class="mb-2">
        <!-- HEADER EDIT SPORT -->
        <div
          v-if="$route.params.id"
          class="d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center" style="gap: 16px">
            <b-button variant="outline-secondary" @click="handleBack">
              <feather-icon icon="ArrowLeftIcon" /> Back to Sports
            </b-button>
            <h4 class="font-weight-bolder mb-0">
              Edit Sport: {{ this.form.name }}
            </h4>
          </div>

          <div>
            <b-button
              variant="outline-secondary"
              @click="showModal('delete')"
              :disabled="loadingDeleteSport"
              class="mr-1 font-weight-bold"
              style="color: red"
            >
              <feather-icon icon="TrashIcon" /> Delete Sport
            </b-button>
            <b-button
              variant="outline-secondary"
              class="mr-1"
              @click="handleBack"
              >Cancel</b-button
            >
            <b-button
              variant="success"
              @click="handleSubmit"
              :disabled="loadingCreateSport"
            >
              <feather-icon icon="SaveIcon" /><Spinner
                v-if="loadingCreateSport"
              />
              <template v-else> Save Changes </template>
            </b-button>
          </div>
        </div>
        <!-- HEADER CREATE SPORT -->
        <div v-else class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center" style="gap: 16px">
            <b-button variant="outline-secondary" @click="handleBack">
              <feather-icon icon="ArrowLeftIcon" /> Back to Sports
            </b-button>
            <h4 class="font-weight-bolder mb-0">Add New Sport</h4>
          </div>

          <div>
            <b-button
              variant="outline-secondary"
              class="mr-1"
              @click="handleBack"
              >Cancel</b-button
            >
            <b-button
              variant="success"
              @click="handleSubmit"
              :disabled="loadingCreateSport"
            >
              <feather-icon icon="PlusIcon" /><Spinner
                v-if="loadingCreateSport"
              />
              <template v-else> Create Sport </template>
            </b-button>
          </div>
        </div>
      </b-col>

      <!-- Sport Management -->
      <b-col cols="12">
        <b-card no-body class="mb-2">
          <b-card-header class="bg-dark text-white p-1">
            🏈 Sport Management
          </b-card-header>
          <b-card-body>
            <h5 class="mt-3 mb-1 text-body font-weight-bold">
              Create Sport Category
            </h5>

            <b-form>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Icon:</span>
                     <b-form-input
                      v-model="form.icon"
                     placeholder="Enter icon link..."
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Display Order:</span>
                    <b-form-input
                      v-model="form.order"
                      :formatter="formatPrice"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group v-if="!$route.params.id">
                <label class="font-weight-bold">Sport Code:</label>
                <b-form-input
                  v-model="form.code"
                   placeholder="Eg. american_football"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <label class="font-weight-bold text-warning">Sport Name:</label>
                <b-form-input
                  v-model="form.name"
                  placeholder="Eg. American Football"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span class="font-weight-bold">Short Name:</span>
                <b-form-input
                  v-model="form.shortName"
                  placeholder="Short version"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span class="font-weight-bold">Default Name:</span>
                <b-form-input
                  v-model="form.defaultName"
                  placeholder="Official sport name"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span class="font-weight-bold">Description:</span>
                <b-form-textarea
                  v-model="form.description"
                  placeholder="Sport description and additional details"
                ></b-form-textarea>
              </b-form-group>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Display:</span>
                    <b-form-radio-group
                      v-model="form.display"
                      :options="yesNoOptions"
                      name="display-options"
                      class="mt-1"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Featured Sport:</span>
                    <b-form-radio-group
                      v-model="form.featured"
                      :options="yesNoOptions"
                      name="featured-options"
                      class="mt-1"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Sport Category:</span>
                    <b-form-select
                      v-model="form.category"
                      :options="categoryOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Primary Region:</span>
                    <b-form-select
                      v-model="form.region"
                      :options="regionOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- League Management -->
      <b-col v-if="$route.params.id" cols="12">
        <b-card no-body>
          <b-card-header
            class="text-white p-1"
            style="background-color: #0d6efd"
          >
            League Management
          </b-card-header>
          <b-card-body class="p-3">
            <b-row
              class="d-flex justify-content-between align-items-center mb-2"
            >
              <span style="font-weight: 800; font-size: 16px"
                >Associated Leagues</span
              >
              <b-button
                size="sm"
                variant="success"
                style="color: black"
                @click="handleAddLeague"
              >
                Add League
              </b-button>
            </b-row>
            <b-row
              v-for="league in leagues"
              :key="league.id"
              class="d-flex justify-content-between align-items-center p-1 mb-1"
              style="background: #f9fafb; border-radius: 10px"
            >
              <div>
                <div class="d-flex justify-content-center align-items-center">
                  <span style="font-weight: 800">{{ league.name }}</span>
                  <b-badge
                    :variant="
                      league.status === 'active' ? 'success' : 'secondary'
                    "
                    pill
                    class="ml-1"
                    >{{
                      league.status === "active" ? "Active" : "Inactive"
                    }}</b-badge
                  >
                </div>
                <span style="font-size: 12px">(Europe - 2024)</span>
              </div>
              <div
                class="d-flex justify-content-center align-items-center"
                style="gap: 10px"
              >
                <span>{{ league.eventCount }} events</span>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  style="color: black"
                  @click="handleEditLeague(league)"
                >
                  <feather-icon icon="EditIcon" /> Edit
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  style="color: red"
                  @click="showModal('remove-league', league)"
                >
                  <feather-icon icon="TrashIcon" /> Remove
                </b-button>
              </div>
            </b-row>
            <p
              v-if="totalLeagues > leagues.length"
              class="cursor-pointer mt-1 show-more"
              @click="currentPageLeagues = currentPageLeagues + 1"
            >
              Show more
            </p>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Betting Configuration -->
      <b-col cols="12">
        <b-card no-body>
          <b-card-header
            class="text-white p-1"
            style="background-color: #0d6efd"
          >
            Betting Configuration
          </b-card-header>
          <b-card-body>
            <b-row class="mt-2">
              <b-col md="6">
                <div class="font-weight-bolder">Default Bet Types:</div>
                <b-row>
                  <b-col
                    v-for="(option, index) in defaultBetTypes"
                    :key="'bet-' + index"
                    md="12"
                    class="mt-1"
                  >
                    <b-form-checkbox
                      v-model="formMarket.defaultBetTypes"
                      :value="option.value"
                    >
                      <span class="font-weight-bold">{{ option.text }}</span>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>

              <b-col md="6">
                <div class="font-weight-bolder">Market Types:</div>
                <b-row>
                  <b-col
                    v-for="(option, index) in marketTypes"
                    :key="'market-' + index"
                    md="12"
                    class="mt-1"
                  >
                    <b-form-checkbox
                      v-model="formMarket.marketTypes"
                      :value="option.value"
                    >
                      <span class="font-weight-bold"> {{ option.text }}</span>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="mt-2 mb-1">
              <b-col md="4">
                <b-form-checkbox v-model="formMarket.allowLiveBetting">
                  <span class="font-weight-bold"> Allow Live Betting</span>
                </b-form-checkbox>
              </b-col>
              <b-col md="4">
                <b-form-checkbox v-model="formMarket.allowCashOut">
                  <span class="font-weight-bold"> Allow Cash Out</span>
                </b-form-checkbox>
              </b-col>
              <b-col md="4">
                <b-form-checkbox v-model="formMarket.allowLiveStreaming">
                  <span class="font-weight-bold">Live Streaming</span>
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <span class="font-weight-bold">Commission Rate (%):</span>
                  <b-form-input
                    v-model="formMarket.commissionRate"
                    :formatter="formatPrice"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <span class="font-weight-bold">Default Odds Format:</span>
                  <b-form-select
                    v-model="formMarket.oddsFormat"
                    :options="oddsFormatOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <b-button variant="secondary" class="mr-1" @click="handleBack"
            >Cancel</b-button
          >
          <b-button
            @click="handleSubmit"
            variant="success"
            :disabled="loadingCreateSport"
          >
            <Spinner v-if="loadingCreateSport" />
            <template v-else>
              {{ $route.params.id ? "Save Changes" : "Create Sport" }}
            </template>
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isSubmitting"
      @ok="handleSubmitModal"
    >
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isSubmitting" />
        <span v-else>Submit</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import {
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
  BBadge,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapState } from "vuex";
import useToastHandler from "@/services/toastHandler";

export default {
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    flatPickr,
    Spinner,
    BCardText,
    BBadge,
  },
  data() {
    return {
      modal: {
        title: "",
        content: "",
      },
      form: {
        icon: "",
        order: null,
        code: "",
        name: "",
        shortName: "",
        defaultName: "",
        description: "",
        display: false,
        featured: false,
        category: "",
        region: "",
      },
      startDate: "",
      endDate: "",
      yesNoOptions: [
        { value: false, text: "No" },
        { value: true, text: "Yes" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      categoryOptions: [
        { value: "Team Sports", text: "Team Sports" },
        { value: "Individual Sports", text: "Individual Sports" },
        { value: "Racing Sports", text: "Racing Sports" },
        { value: "Combat Sports", text: "Combat Sports" },
        { value: "Motorsport", text: "Motorsport" },
      ],
      regionOptions: [
        { value: "Global", text: "Global" },
        { value: "Australia", text: "Australia" },
        { value: "North America", text: "North America" },
        { value: "Europe", text: "Europe" },
        { value: "Asia", text: "Asia" },
      ],
      formMarket: {
        defaultBetTypes: [],
        marketTypes: [],
        commissionRate: "",
        oddsFormat: "",
        allowCashOut: false,
        allowLiveBetting: false,
        allowLiveStreaming: false,
      },
      defaultBetTypes: [
        { value: "Match Result", text: "Match Result" },
        { value: "handicap", text: "Handicap" },
        { value: "overUnder", text: "Over/Under" },
        { value: "outrightWinner", text: "Outright Winner" },
        { value: "bothTeamsScore", text: "Both Teams to Score" },
        { value: "correctScore", text: "Correct Score" },
      ],
      marketTypes: [
        { value: "preMatch", text: "Pre-Match" },
        { value: "live", text: "Live" },
        { value: "specials", text: "Specials" },
        { value: "outrights", text: "Outrights" },
        { value: "props", text: "Props" },
        { value: "futures", text: "Futures" },
      ],
      oddsFormatOptions: [
        { value: "Decimal", text: "Decimal" },
        { value: "Fractional", text: "Fractional" },
        { value: "American", text: "American" },
      ],
      leagues: [],
      perPageLeagues: 10,
      currentPageLeagues: 1,
      totalLeagues: 0,
      sportItem: null,
    };
  },
  async created() {
    if (!this.$route.params.id) return;
    await this.fetchLeagues();
    const res = await this.getListSport({
      id: this.$route.params.id,
    });
    if (res.data) {
      const sportItem = res.data[0];
      this.sportItem = sportItem;
      this.form = {
        ...this.form,
        code: sportItem.code,
        icon: sportItem.icon,
        order: sportItem.orderNumber,
        name: sportItem.name,
        shortName: sportItem.shortName,
        defaultName: sportItem.defaultName,
        description: sportItem.description,
        featured: !!sportItem.isFeatured,
        display: sportItem.status === "active",
        category: sportItem.category,
        region: sportItem.region,
      };

      this.formMarket = {
        ...this.formMarket,
        commissionRate: sportItem.commissionRate,
        oddsFormat: sportItem.oddsFormat,
        allowCashOut: !!sportItem.allowCashOut,
        allowLiveBetting: !!sportItem.allowLiveBetting,
        allowLiveStreaming: !!sportItem.allowLiveStreaming,
      };
    }
  },
  watch: {
    currentPageLeagues(newPage) {
      if (newPage > 1) this.fetchLeagues();
    },
  },
  computed: {
    ...mapState("sport/create", ["loadingCreateSport", "loadingDeleteSport"]),
    isSubmitting() {
      return this.loadingDeleteSport;
    },
  },
  methods: {
    ...mapActions({
      createSport: "sport/create/createSport",
      getListSport: "sport/list/getListSport",
      deleteSport: "sport/create/deleteSport",
      getListLeagueOfSport: "sport/list/getListLeagueOfSport",
      deleteLeague: "sport/create/deleteLeague",
    }),
    handleBack() {
      this.$router.push({ name: "trading-sports" });
    },
    async handleSubmit() {
      const res = await this.createSport({
        name: this.form.name,
        shortName: this.form.shortName,
        defaultName: this.form.defaultName,
        description: this.form.description,
        code: this.form.code,
        icon: this.form.icon,
        orderNumber: this.form.order ? Number(this.form.order) : null,
        source: !this.$route.params.id ? "sporting" : this.sportItem.source,
        status: this.form.display ? "active" : "disabled",
        isFeatured: this.form.featured ? 1 : 0,
        category: this.form.category,
        region: this.form.region,
        advanceData: {
          commissionRate: Number(this.formMarket.commissionRate),
          oddsFormat: this.formMarket.oddsFormat,
          allowCashOut: this.formMarket.allowCashOut ? 1 : 0,
          allowLiveBetting: this.formMarket.allowLiveBetting ? 1 : 0,
          allowLiveStreaming: this.formMarket.allowLiveStreaming ? 1 : 0,
        },
      });
      if (res) {
        if (!this.$route.params.id)
          this.showToastSuccess(true, "New sport created successfully!");
        if (this.$route.params.id)
          this.showToastSuccess(true, "The sport updated successfully!");
        this.handleBack();
      }
    },
    formatPrice(value) {
      value = value.replace(/[^0-9.]/g, "");

      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      if (value.includes(".")) {
        const decimalPart = value.split(".")[1];
        if (decimalPart.length > 2) {
          const integerPart = value.split(".")[0];
          value = `${integerPart}.${decimalPart.slice(0, 2)}`;
        }
      }

      return value;
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete")
        this.setModal(
          "Delete Sport",
          "Are you sure you want to delete this sport?"
        );

      if (type === "remove-league")
        this.setModal(
          "Delete League",
          `Are you sure you want to delete this league ${item.name}?`
        );

      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;

      if (type === "delete") await this.handleDelete();
      if (type === "remove-league") await this.handleRemoveLeague(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleDelete() {
      const res = await this.deleteSport(this.$route.params.id);
      if (res) {
        this.showToastSuccess(true, "Sport deleted successfully!");
        this.handleBack();
        this.$refs.modal.hide();
      }
    },
    async handleRemoveLeague(item) {
      const res = await this.deleteLeague(item.id);
      if (res) {
        this.showToastSuccess(true, "The league deleted successfully!");
        this.fetchLeagues()
      }
    },
    async fetchLeagues() {
      const data = await this.getListLeagueOfSport({
        limit: this.perPageLeagues,
        page: this.currentPageLeagues,
        sportId: this.$route.params.id,
      });
      if (!data && data.data.length <= 0)
        return this.showToastError(false, "Error fetching leagues list");
      if (this.currentPageLeagues === 1) {
        this.leagues = data.data;
      } else {
        this.leagues = [...this.leagues, ...data.data];
      }
      this.totalLeagues = data.pagination.total;
    },
    handleEditLeague(league) {
      this.$router.push(
        `/trading/sports/${this.$route.params.code}/${this.$route.params.id}/leagues/${league.id}`
      );
    },
    handleAddLeague() {
      this.$router.push(
        `/trading/sports/${this.$route.params.code}/${this.$route.params.id}/leagues/create`
      );
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.container-sport {
  max-width: 1024px;
  margin: auto;
  padding: 16px;
  padding-top: 0;
}

.show-more {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  color: blue;
}
</style>
